import React, { useEffect, useState } from "react";
import avt from "../../../assets/media/img/avatar.svg";
import useAuth from "../../../hooks/useAuth";
import loading from "../../../assets/media/loader/dual-ring.svg";
import useLogout from "../../../hooks/useLogout";
import PopUp from "../../Common/popup";
import axios from "../../../api/axios";
import { useNavigate } from "react-router-dom";

const U_URL = "/user/update";

const MyDetails = () => {
  const { auth } = useAuth();
  const [email] = useState(auth.email);
  const [username] = useState(auth.username);
  const [inputEmail, setInputEmail] = useState(email);
  const [inputUsername, setInputUsername] = useState(username);
  const [changeDetected, setChangeDetected] = useState(false);
  const [emailErr, setEmailErr] = useState();
  const [usernameErr, setUsernameErr] = useState();
  const [saving, setSaving] = useState(false);
  const [poupParams, setPopupParams] = useState();
  const logout = useLogout();
  const Nav = useNavigate();
  const signOut = async () => {
    await logout();
    Nav("/login");
  };
  useEffect(() => {
    if (inputEmail != email || inputUsername != username)
      setChangeDetected(true);
    else setChangeDetected(false);
  }, [inputEmail, inputUsername]);
  const restInputs = () => {
    setInputEmail(email);
    setInputUsername(username);
    setEmailErr();
    setUsernameErr();
  };
  const valideUsername = () => {
    if (!inputUsername) {
      setUsernameErr("is required");
      return false;
    }
    if (inputUsername.length < 4) {
      setUsernameErr("is too short");
      return false;
    }
    const pattern = /^[a-zA-Z0-9_]+$/;
    if (!pattern.test(inputUsername)) {
      setUsernameErr("contains unexpected characters");
      return false;
    }
    return true;
  };
  const valideEmail = () => {
    if (!inputEmail) {
      setEmailErr("is required");
      return false;
    }
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!pattern.test(inputEmail)) {
      setEmailErr("is not valide");
      return false;
    }
    return true;
  };
  const handleSave = async () => {
    setSaving(true);
    if (valideUsername() && valideEmail()) {
      try {
        const response = await axios.put(
          U_URL,
          JSON.stringify({
            id: auth.userId,
            username: inputUsername,
            email: inputEmail,
          }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        setSaving(false);
        setPopupParams({
          status: "done",
          message: "For security purposes you need to login again in ",
          timeout: 6,
        });
        const countdown = setTimeout(() => {
          signOut();
        }, 6000);
      } catch (e) {
        if (e.response.data?.param === "username")
          setUsernameErr(" already exists");
        if (e.response.data?.param === "email") setEmailErr(" already exists");
        setSaving(false);
      }
    } else {
      setSaving(false);
    }
  };

  return (
    <div className="settings-tabb pt-12px">
      <PopUp
        status={poupParams?.status}
        message={poupParams?.message}
        timeout={poupParams?.timeout}
      />
      <div className="py-20px border-b md:gap-32px gap-16px border-primary-100 dark:border-accent-700 flex justify-between sm:flex-row flex-col">
        <div className="">
          <p className="text-primary-900 dark:text-accent-200 font-bold text-lg mb-1">
            Personal info
          </p>
          <p className="text-accent-400 dark:text-accent-300 m-0 mt-2 text-sm  ">
            Update your photo and personal details here
          </p>
        </div>
        <div className="flex gap-20px w-full sm:w-auto text-sm">
          <button
            className={`w-full sm:w-auto py-10px px-20px rounded-lg font-medium text-accent-400 cursor-pointer bg-white border dark:bg-accent-800 dark:border-accent-600 border-accent-100 duration-300 h-fit hover:opacity-90`}
            onClick={() => restInputs()}
          >
            Cancel
          </button>
          <button
            className="w-full sm:w-auto py-10px px-20px rounded-lg font-medium text-white cursor-pointer bg-primary-500 border-0 duration-300 h-fit disabled:opacity-50 hover:opacity-90 disabled:hover:opacity-50 disabled:bg-accent-200 dark:disabled:bg-accent-600"
            disabled={!changeDetected}
            onClick={() => handleSave()}
          >
            {saving ? (
              <img style={{ maxWidth: "24px" }} src={loading} alt="" />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
      <div className="py-20px border-b border-primary-100 dark:border-accent-700 flex justify-between">
        <div className="flex md:gap-32px gap-10px max-w-[1100px] justify-between w-full sm:flex-row flex-col">
          <label
            htmlFor="username"
            className={`text-accent-400 dark:text-accent-300 m-0 text-sm font-medium ${
              usernameErr ? "error-message" : ""
            }`}
          >
            Username {usernameErr && usernameErr}
          </label>
          <div
            className={`focus-within:outline focus-within:outline-primary-500 focus-within:border-transparent flex sm:max-w-[512px] w-full bg-white dark:bg-accent-800 font-medium m-0 box-border rounded-lg border border-accent-100 dark:border-none outline-none shadow-sm overflow-hidden ${
              usernameErr ? "input-error" : ""
            }`}
          >
            <div className="flex items-center px-3">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
                  className="stroke-accent-400"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              className="h-full w-full text-primary-900 dark:text-accent-200 bg-transparent py-12px px-16px border-none outline-none box-border font-semibold"
              type="text"
              placeholder="username"
              value={inputUsername}
              id="username"
              onChange={(e) => {
                {
                  setInputUsername(e.target.value);
                  setEmailErr();
                  setUsernameErr();
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className="py-20px border-b border-primary-100 dark:border-accent-700 flex justify-between ">
        <div className="row-container | flex md:gap-32px gap-10px max-w-[1100px] justify-between w-full sm:flex-row flex-col">
          <label
            htmlFor="email"
            className={`text-accent-400 dark:text-accent-300 m-0 text-sm font-medium ${
              emailErr ? "error-message" : ""
            }`}
          >
            Email Adress {emailErr && emailErr}
          </label>
          <div
            className={`iconed-input | focus-within:outline focus-within:outline-primary-500 focus-within:border-transparent flex sm:max-w-[512px] w-full bg-white dark:bg-accent-800 font-medium m-0 box-border rounded-lg border border-accent-100 dark:border-none outline-none shadow-sm overflow-hidden ${
              emailErr ? "input-error" : ""
            }`}
          >
            <div className="flex items-center px-3">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 12H5.88197C6.56717 12 7.19357 12.3871 7.5 13C7.80643 13.6129 8.43283 14 9.11803 14H14.882C15.5672 14 16.1936 13.6129 16.5 13C16.8064 12.3871 17.4328 12 18.118 12H21.5M8.96656 4H15.0334C16.1103 4 16.6487 4 17.1241 4.16396C17.5445 4.30896 17.9274 4.5456 18.2451 4.85675C18.6043 5.2086 18.8451 5.6902 19.3267 6.65337L21.4932 10.9865C21.6822 11.3645 21.7767 11.5535 21.8434 11.7515C21.9026 11.9275 21.9453 12.1085 21.971 12.2923C22 12.4992 22 12.7105 22 13.1331V15.2C22 16.8802 22 17.7202 21.673 18.362C21.3854 18.9265 20.9265 19.3854 20.362 19.673C19.7202 20 18.8802 20 17.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V13.1331C2 12.7105 2 12.4992 2.02897 12.2923C2.05471 12.1085 2.09744 11.9275 2.15662 11.7515C2.22326 11.5535 2.31776 11.3645 2.50675 10.9865L4.67331 6.65337C5.1549 5.69019 5.3957 5.2086 5.75495 4.85675C6.07263 4.5456 6.45551 4.30896 6.87589 4.16396C7.35125 4 7.88969 4 8.96656 4Z"
                  className="stroke-accent-400"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              className="h-full w-full text-primary-900 dark:text-accent-200 bg-transparent py-12px px-16px border-none outline-none box-border font-semibold"
              type="text"
              placeholder="you@email.com"
              value={inputEmail}
              onChange={(e) => {
                setInputEmail(e.target.value);
                setEmailErr();
                setUsernameErr();
              }}
              id="email"
            />
          </div>
        </div>
      </div>
      <div className="py-20px  flex justify-between ">
        <div className="flex md:gap-32px gap-16px max-w-[1100px] justify-between w-full sm:flex-row flex-col">
          <div>
            <label
              className="text-accent-400 dark:text-accent-300 m-0 text-sm font-medium"
              htmlFor="email"
            >
              Your photo
            </label>
            <p className=" text-accent-400 dark:text-accent-300 m-0 mt-2 text-sm">
              This will be displayed on your profile
            </p>
          </div>
          <div className="flex justify-between gap-20px sm:max-w-[512px] w-full">
            <div className="bg-primary-100 h-fit flex max-w-[64px] w-full aspect-square rounded-full">
              <img className="w-full aspect-square" src={avt} alt="" />
            </div>
            <div className="relative flex flex-col gap-10px bg-white dark:bg-accent-800 dark:border-none p-16px w-full rounded-lg border border-accent-100 shadow-sm outline-none box-border focus-within:outline focus-within:border-transparent focus-within:outline-primary-500">
              <input
                className="opacity-0 absolute top-0 bottom-0 left-0 right-0"
                type="file"
                name=""
                id=""
              />
              <span className="w-full max-w-[48px] m-auto">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="24"
                    className="dark:fill-accent-600"
                    fillOpacity="0.4"
                  />
                  <rect
                    x="8"
                    y="8"
                    width="32"
                    height="32"
                    rx="16"
                    className="dark:fill-accent-600"
                    fillOpacity="0.8"
                  />
                  <mask
                    id="mask0_135_10724"
                    maskUnits="userSpaceOnUse"
                    x="12"
                    y="12"
                    width="24"
                    height="24"
                  >
                    <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_135_10724)">
                    <path
                      d="M18.5 32C16.9833 32 15.6875 31.475 14.6125 30.425C13.5375 29.375 13 28.0917 13 26.575C13 25.275 13.3917 24.1167 14.175 23.1C14.9583 22.0833 15.9833 21.4333 17.25 21.15C17.6667 19.6167 18.5 18.375 19.75 17.425C21 16.475 22.4167 16 24 16C25.95 16 27.6042 16.6792 28.9625 18.0375C30.3208 19.3958 31 21.05 31 23C32.15 23.1333 33.1042 23.6292 33.8625 24.4875C34.6208 25.3458 35 26.35 35 27.5C35 28.75 34.5625 29.8125 33.6875 30.6875C32.8125 31.5625 31.75 32 30.5 32H25C24.45 32 23.9792 31.8042 23.5875 31.4125C23.1958 31.0208 23 30.55 23 30V24.85L21.4 26.4L20 25L24 21L28 25L26.6 26.4L25 24.85V30H30.5C31.2 30 31.7917 29.7583 32.275 29.275C32.7583 28.7917 33 28.2 33 27.5C33 26.8 32.7583 26.2083 32.275 25.725C31.7917 25.2417 31.2 25 30.5 25H29V23C29 21.6167 28.5125 20.4375 27.5375 19.4625C26.5625 18.4875 25.3833 18 24 18C22.6167 18 21.4375 18.4875 20.4625 19.4625C19.4875 20.4375 19 21.6167 19 23H18.5C17.5333 23 16.7083 23.3417 16.025 24.025C15.3417 24.7083 15 25.5333 15 26.5C15 27.4667 15.3417 28.2917 16.025 28.975C16.7083 29.6583 17.5333 30 18.5 30H21V32H18.5Z"
                      className="fill-accent-400"
                    />
                  </g>
                </svg>
              </span>
              <p className="text-accent-300 md:text-sm text-xs text-center max-w-[290px] m-auto cursor-pointer">
                <span>Click to upload</span> or drag and drop SVG, PNG, JPG or
                GIF (max. 800x400px)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyDetails;
